import React from "react";
import PageNotFound from "app/pages/PageNotFound";
import { useAgentAccountDetails } from "shared/hooks/common";

/**
 * Route-level authorization: renders children only if current user role is in the authorized list.
 * Use with protected routes: protection (refresh token) is checked first, then role.
 * authorized: array of role keys allowed for this route; empty/absent = allow all.
 */
function AuthorizedRoute({ authorized, children }) {
  const { agentRole } = useAgentAccountDetails();
  if (!authorized || authorized.length === 0) {
    return children;
  }
  if (!agentRole || !authorized.includes(agentRole)) {
    return (
      <PageNotFound
        statusCode={403}
        title=" "
        subTitle="You are not authorized to access this page."
        style={{ backgroundColor: "rgb(244, 247, 255)" }}
      />
    );
  }
  return children;
}

export default React.memo(AuthorizedRoute);
